<template>
    <div>
        <div class="header-title">Operators</div>
        <div class="d-flex justify-content-center align-items-center h-100" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <div class="container">
            <div v-if="!isLoading">
                <div class="py-3 d-flex justify-content-end">
                    <button v-if="inviteOperator" class="btn btn-common" v-b-modal.invite-operator-modal>Invite</button>
                </div>
                <b-table class="text-center" responsive :fields="operatorsField" :items="operators" tbody-tr-class="rowClass" @row-clicked="handleRowClicked">
                    <template #cell(email)="data">
                        {{ data.item.email }}
                    </template>
                    <template #cell(access)="data">
                        <b-icon :icon="indicatorList[data.item.status == 'active' ? true : false]" :variant="colorList[data.item.status == 'active' ? true : false]"></b-icon>
                    </template>
                    <template #cell(setting)="data">
                        <b-icon :icon="indicatorList[data.item.permission.SETTING]" :variant="colorList[data.item.permission.SETTING]"></b-icon>
                    </template>
                    <!-- <template #cell(approve)="data">
                        <b-icon :icon="indicatorList[data.item.permission.APPROVE]" :variant="colorList[data.item.permission.APPROVE]"></b-icon>
                    </template> -->
                    <template #cell(invite)="data">
                        <b-icon :icon="indicatorList[data.item.permission.INVITE]" :variant="colorList[data.item.permission.INVITE]"></b-icon>
                    </template>
                    <template #cell(withdraw)="data">
                        <b-icon :icon="indicatorList[data.item.permission.WITHDRAW]" :variant="colorList[data.item.permission.WITHDRAW]"></b-icon>
                    </template>
                    <template #cell(action)="data">
                        <b-button v-if="settingOperator" class="btn btn-common mr-3" @click="showEditOperator(data)">
                            <inline-svg
                                :src="require('../assets/icon/edit.svg')"
                                aria-label="swap"
                                id="edit"
                            ></inline-svg>
                        </b-button>

                        <b-icon v-show="root" icon="chevron-right" @click="roataeIcon(this)"></b-icon>
                        <!-- {{ data.item.permission.WITHDRAW }} -->
                    </template>

                    <!-- start expended body -->
                    <template slot="row-details" slot-scope="row" v-if="root">
                        <div class="d-flex justify-content-center align-items-center h-100" v-if="isListLoading">
                            <b-spinner variant="success" label="Spinning"></b-spinner>
                        </div>
                        <div v-else>
                            <div>
                                <div class="border-top title text-left py-3">Withdraw Limit</div>
                                <b-table :fields="operatorsWithdrawLimitField" :items="operatorWithdrawLimits[row.item.email]??[]" responsive outlined show-empty empty-filtered-text="No Data">
                                    <template #cell(coin)="data">
                                        {{ data.item.crypto }}
                                    </template>
                                    <template #cell(single_limit)="data">
                                        {{ data.item.single_limit??"Unset" }}
                                    </template>
                                    <template #cell(hourly_limit)="data">
                                        {{ data.item.hourly_limit??"Unset" }}
                                    </template>
                                    <template #cell(daily_limit)="data">
                                        {{ data.item.daily_limit??"Unset" }}
                                    </template>
                                    <template #cell(action)="data">
                                        <b-button class="btn btn-common mr-3" @click="showEditOperatorsWithdrawLimit(data.item)">
                                            <inline-svg
                                                :src="require('../assets/icon/edit.svg')"
                                                aria-label="swap"
                                                id="edit"
                                            ></inline-svg>
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </template>
                    <!-- end expended body -->
                </b-table>
            </div>
        </div>

        <!-- Add Operators Modal -->
        <b-modal id="invite-operator-modal" ref="invite-operator-modal" hide-footer title="Invite Operator" centered>
            <form id="register" @submit.stop.prevent="inviteNewOperator">
                <div class="form-group text-center">
                    <label for="email">Email</label>
                    <!-- <input type="text" class="form-control" id="email" placeholder="Enter Email" v-model="$v.form.email.$model"> -->
                    <b-form-input
                    id="example-input-1"
                    placeholder="Enter email"
                    name="example-input-1"
                    v-model="$v.inviteForm.email.$model"
                    :state="validateState('email','inviteForm')"
                    aria-describedby="input-1-live-feedback"
                    required
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required field.</b-form-invalid-feedback>
                </div>
                <div class="mt-3">
                    <button class="activate-btn">Invite</button>                    
                </div>
            </form>
        </b-modal>

        <!-- Edit Operator Modal -->
        <b-modal id="edit-operator-modal" ref="edit-operator-modal" hide-footer title="Edit Permission" @hidden="onEditModalHidden" centered>
            <div class="d-flex flex-wrap">
                <div class="col-12 p-2 text-center">
                    <div class="col-6">
                        <label class="edit-checkbox-container">
                            ACCESS
                            <input v-model="permissionStatus" type="checkbox" :checked="permissionStatus">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div v-for="(permission,key) in localPermissions" :key="`permission${key}`" class="col-6 p-2 text-center">
                    <label class="edit-checkbox-container">
                        {{key}}
                        <input v-model="localPermissions[key]" type="checkbox" :checked="permission">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>

            <div class="mt-3">
                <button @click="updatePermission" class="activate-btn">Update</button>
            </div>
        </b-modal>


        <!-- Update Threshold Modal -->
        <b-modal ref="edit-withdraw-limit-modal" hide-footer :title="`EDIT ${withdrawLimitForm.crypto} WITHDRAW LIMIT`" centered>
            <div class="d-flex flex-column text-center">
                <form id="update-threshold-form" class="modal-form" @submit.stop.prevent="updateWithdrawLimit">      
                    <div class="form-group">
                        <label for="input-live">Single Limit</label>
                        <b-form-input
                            id="example-input-1"
                            placeholder="Enter single limit"
                            v-model="$v.withdrawLimitForm.single_limit.$model"
                            :state="validateState('single_limit','withdrawLimitForm')"
                            aria-describedby="input-1-live-feedback"
                            type="number"
                            step="0.0001"
                            ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">Please key in number</b-form-invalid-feedback>
                    </div>

                    <div class="form-group">
                        <label for="input-live">Daily Limit</label>
                        <b-form-input
                            id="example-input-1"
                            placeholder="Enter daily limit"
                            v-model="$v.withdrawLimitForm.daily_limit.$model"
                            :state="validateState('daily_limit','withdrawLimitForm')"
                            aria-describedby="input-1-live-feedback"
                            type="number"
                            step="0.0001"
                            ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">Please key in number</b-form-invalid-feedback>
                    </div>

                    <div class="form-group">
                        <label for="input-live">Hourly Limit</label>
                        <b-form-input
                            id="example-input-1"
                            placeholder="Enter hour limit"
                            v-model="$v.withdrawLimitForm.hourly_limit.$model"
                            :state="validateState('hourly_limit','withdrawLimitForm')"
                            aria-describedby="input-1-live-feedback"
                            type="number"
                            step="0.0001"
                            ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">Please key in number</b-form-invalid-feedback>
                    </div>

                    <div class="form-group">
                        <div class="mt-5 mb-5 w-100">
                            <button type="submit" class="submit-btn">Edit</button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import InlineSvg from "vue-inline-svg";
    import api from "../helper/api.js";
    import { required, email } from "vuelidate/lib/validators";
    import Swal from 'sweetalert2';

    export default {
        name:"Operators",
        components: {
            InlineSvg,
        },   
        data(){
            return{
                root:localStorage.getItem('root'),
                operatorsField: [
                   'email',
                   'access',
                   'setting',
                   'invite',
                   'withdraw',
                   'action',
                ],
                operatorsWithdrawLimitField: [
                   'coin',
                   'single_limit',
                   'hourly_limit',
                   'daily_limit',
                   'action'
                ],
                operators:[],
                inviteOperator:(localStorage.getItem('inviteOperator')==='true'),
                settingOperator:(localStorage.getItem('settingOperator')==='true'),
                isLoading:true,
                inviteForm:{
                    email:""    
                },
                indicatorList:{
                    true:'check-lg',
                    false:'x-lg'
                },
                colorList:{
                    true:'success',
                    false:'danger'
                },
                permissionStatus:true,
                localPermissions:null,
                permissions:null,   
                operatorId:null,
                allOpenRows: [],
                operatorWithdrawLimits : null,
                isListLoading : true,
                operatorWithdrawLimitsData:[],
                withdrawLimitForm:{
                    id:"",
                    crypto:"",
                    single_limit:"",
                    hourly_limit:"",
                    daily_limit:""
                }
            }
        },
        validations: {
            inviteForm: {
                email: {
                    required,
                    email
                },
            },
            withdrawLimitForm:{
                daily_limit:{
                    // numeric
                },
                hourly_limit:{
                    // numeric
                },
                single_limit:{
                    // numeric
                }
            }
        },


        watch:{
            'localPermissions.INVITE':function(val){
                this.localPermissions.SETTING = val;
            },
            'localPermissions.SETTING':function(val){
                this.localPermissions.INVITE = val;
            }
        },
        // watch:{
        //     'localPermissions.INVITE':function(val){
        //         this.localPermissions.SETTING = val;
        //     },
        //     'localPermissions.SETTING':function(val){
        //         this.localPermissions.INVITE = val;
        //     }
        // },

        async mounted() {
            await this.getOperators();
        },

        methods: {
            validateState(name,form) {
                const { $dirty, $error } = this.$v[form][name];
                return $dirty ? !$error : null;
            },
            handleRowClicked(item) {
                if(!this.root){
                    return;
                }
                
                this.allOpenRows.map((ele) => {
                    if (ele.id !== item.id && ele._showDetails) {
                    this.$set(ele, "_showDetails", !ele._showDetails);
                    }
                });
                this.allOpenRows = [];
                this.$set(item, "_showDetails", !item._showDetails);
                this.allOpenRows.push(item);

                this.getOperatorsWithdrawLimit().then(()=>{
                    this.isListLoading = false;
                });

            },
            async getOperatorsWithdrawLimit(){
                this.isListLoading = true;
                try{
                    const response = await api.apiCall('core','GET','/operator-settings');
                    const operatorsList = response.message.reduce((key,item)=>{
                        key[item.email] = key[item.email] || [];
                        key[item.email].push(item);
                        return key;
                    },{});

                    this.operatorWithdrawLimits = operatorsList;

                }catch(error){
                    console.error(error);
                }
            },  
            async getOperators(){
                try{
                    const response = await api.apiCall('core','GET','/operators/all');
                    this.operators = response.message;
                    this.isLoading = false;
                    // console.log(response);
                }catch(error){
                    console.error(error);
                }
            },
            async inviteNewOperator(){
                let params = {
                    email : this.inviteForm.email
                };

                try{
                    const response = await api.apiCall('core','POST','/operators/invite',params);
                    console.log(response);
                    Swal.fire({
                        text: "Invite Success",
                        icon: 'success'
                    });
                    this.$refs['invite-operator-modal'].hide();

                }catch(error){
                    console.error(error);
                    Swal.fire({
                        text: error.message,
                        icon: 'error',
                        // confirmButtonColor: '#33AD4A',
                    });
                }
            },

            async updatePermission(){
                let params = {
                    status:this.permissionStatus,
                    permission:this.localPermissions,
                    id:this.operatorId
                };

                try{
                    const response = await api.apiCall('core','POST','/operators/editpermission',params);
                    console.log(response);
                    Swal.fire({
                        text: "Update Success",
                        icon: 'success'
                    });
                    this.$refs['edit-operator-modal'].hide();
                    this.isLoading = true;
                    this.getOperators();

                }catch(error){
                    console.error(error);
                    Swal.fire({
                        text: error.message,
                        icon: 'error',
                        // confirmButtonColor: '#33AD4A',
                    });
                }
            },  

            showEditOperator(data){
                let status = {
                    'active' : true,
                    'suspend' : false
                };
                this.permissionStatus = status[data.item.status];
                this.localPermissions = JSON.parse(JSON.stringify(data.item.permission));
                this.operatorId = data.item.id
                this.$refs['edit-operator-modal'].show();
            },

            showEditOperatorsWithdrawLimit(data){
                console.log(data)
                this.withdrawLimitForm = {
                    id: data.id,
                    crypto: data.crypto,
                    single_limit: data.single_limit,
                    daily_limit: data.daily_limit,
                    hourly_limit: data.hourly_limit
                }
                this.$refs['edit-withdraw-limit-modal'].show();
            },

            async updateWithdrawLimit(){
                let params = {
                    id: this.withdrawLimitForm.id.toString(),
                    crypto: this.withdrawLimitForm.crypto,
                    single_limit: parseFloat(this.withdrawLimitForm.single_limit),
                    daily_limit: parseFloat(this.withdrawLimitForm.daily_limit),
                    hourly_limit: parseFloat(this.withdrawLimitForm.hourly_limit)
                };

                try{
                    await api.apiCall('core','POST','/operator-settings/edit',params);
                    Swal.fire({
                        text: "Update Withdraw Limit Success",
                        icon: 'success'
                    });
                    this.$refs['edit-withdraw-limit-modal'].hide();
                    this.getOperatorsWithdrawLimit().then(()=>{
                        this.isListLoading = false;
                    });

                }catch(error){
                    console.error(error);
                    Swal.fire({
                        text: error.message,
                        icon: 'error',
                        // confirmButtonColor: '#33AD4A',
                    });
                }
            },

            onEditModalHidden(){
                
            },
        },
    }
</script>

<style scoped>
@import '../css/styles.css';

.add-operator-btn{
    border: 1px solid var(--primary);
}

.edit-checkbox-container{
    position: relative;
    width: 50%;
}

.edit-checkbox-container input{
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.edit-checkbox-container .checkmark {
  position: absolute;
  top: 0;
  right: -45px;
  height: 25px;
  width: 25px;
  background-color: var(--gray);
}

/* When the checkbox is checked, add a blue background */
.edit-checkbox-container input:checked ~ .checkmark {
  background-color: var(--primary);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.edit-checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.edit-checkbox-container .checkmark:after {
  left: 9px;
  top: 3px;
  width: 8px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


@media only screen and (min-width:1025px) {
    .edit-checkbox-container .checkmark {
        position: absolute;
        top: 0;
        right: -22px;
        height: 25px;
        width: 25px;
        background-color: var(--gray);
    }
}
</style>